import { ISuppliersResult } from 'API/Suppliers/suppliers';
import { ICoordinate } from 'Context/SuppliersContext';
import { ISuppliersDoctors } from 'Context/SuppliersContext/DoctorsSuppliersContext';
import { ISuppliersTherapy } from 'Context/SuppliersContext/TherapySuppliersContext';
import { SUPPLIER_RESULT_FILTER } from 'Enum/suppliers';
import { getHaversineDistance } from 'Utils/getHaversineDistance';
import { TherapyFilter } from './therapyFilter';
import { DoctorFilter } from './doctorFilter';

export interface IAction {
  type: string;
  payload: any;
}

export function SuppliersReducer(
  state: ISuppliersTherapy | ISuppliersDoctors,
  action: IAction
) {
  switch (action.type) {
    case SUPPLIER_RESULT_FILTER.Init: {
      const results = action.payload;
      const filteredResults = action.payload;
      return { ...state, results, filteredResults };
    }
    case SUPPLIER_RESULT_FILTER.Therapy: {
      const filteredResults = TherapyFilter(
        state.results,
        action.payload.value
      );
      return { ...state, filteredResults };
    }
    case SUPPLIER_RESULT_FILTER.doctors: {
      const filteredResults = DoctorFilter(state.results, action.payload.value);
      return { ...state, filteredResults };
    }
    default:
      return state;
  }
}

/**
 * Given 2 suppliers with 4 possible coordinates return the shortest coordinate of each supplier
 * @param location User Location
 * @param a Supplier
 * @param b Supplier
 * @returns 2 Coordinates
 */
export function getShortestTwoCoordinates(
  location: ICoordinate,
  a: ISuppliersResult,
  b: ISuppliersResult
) {
  let firstCoordsA: ICoordinate | undefined,
    secondCoordsA: ICoordinate | undefined,
    firstCoordsB: ICoordinate | undefined,
    secondCoordsB: ICoordinate | undefined;
  if (a.firstLatitude && a.firstLongitude)
    firstCoordsA = {
      latitude: a.firstLatitude,
      longitude: a.firstLongitude,
    };
  if (a.secondLatitude && a.secondLongitude)
    secondCoordsA = {
      latitude: a.secondLatitude,
      longitude: a.secondLongitude,
    };
  if (b.firstLatitude && b.firstLongitude)
    firstCoordsB = {
      latitude: b.firstLatitude,
      longitude: b.firstLongitude,
    };
  if (b.secondLatitude && b.secondLongitude)
    secondCoordsB = {
      latitude: b.secondLatitude,
      longitude: b.secondLongitude,
    };

  let coordsA: ICoordinate | undefined;
  if (firstCoordsA && secondCoordsA) {
    if (
      getHaversineDistance(location, firstCoordsA) <
      getHaversineDistance(location, secondCoordsA)
    )
      coordsA = firstCoordsA;
    else coordsA = secondCoordsA;
  }
  if (firstCoordsA) coordsA = firstCoordsA;
  if (secondCoordsA) coordsA = secondCoordsA;

  let coordsB: ICoordinate | undefined;
  if (firstCoordsB && secondCoordsB) {
    if (
      getHaversineDistance(location, firstCoordsB) <
      getHaversineDistance(location, secondCoordsB)
    )
      coordsB = firstCoordsB;
    else coordsB = secondCoordsB;
  }
  if (firstCoordsB) coordsB = firstCoordsB;
  if (secondCoordsB) coordsB = secondCoordsB;

  return { coordsA, coordsB };
}
